import styled from "styled-components"
import { color } from "helpers/styled"
import PromoContainer from "../PromoContainer"

const Promotion = styled(PromoContainer)`
  color: ${color("white")};
  --promo-bg: linear-gradient(90deg, ${color("skyBlue")} 0%, ${color("mediumBlue")} 64%, ${color("purple")} 100%);
`

export default Promotion
